export enum InsuranceType {
  AIR_PAYOUT = "air_payout",
  AIR_LUGGAGE = "air_luggage",
}
export enum AirBundleDocumentFile {
  PIR = "pirReference",
  BOARDING = "boardingPassOrBookingReference",
  PASSPORT = "passportOrId",
  BAGGAGE_TAG = "baggageTag",
}

export enum AirBundleDocumentParam {
  PIR = "pir_reference",
  BOARDING = "boarding_pass_or_booking_reference",
  PASSPORT = "passport_or_id",
  BAGGAGE_TAG = "baggage_tag",
}
